import { useMemo } from "react";
import { GrIcon, GrIconButton, GrStack, GrTooltip, GrTypography } from "@jnpmedi/grebob";
import { MvnMessage } from "@newLibs/utils";
import { useDismissedTooltip } from "@newHooks/common/useDismissedTooltip";
import { baseZIndex } from "@assets/theme/baseDefine/baseZIndex";
import Style from "./NaviList.styled";
import { Navi, NaviKey } from "../../../newLayouts/common/type";
import { DOCS_CONTACT_LANG } from "@maven-msg/lang/docs";

const TOOLTIP_DISMISSED_KEY = "navi-tooltip-dismissed";

type NaviItemProps = {
  naviItem: Navi;
  isActive: boolean;
};

export function NaviItem({ naviItem, isActive }: NaviItemProps) {
  const { label, link, startIcon, endIcon } = naviItem;

  const { isDismissedTooltip, handleDismissedTooltip } = useDismissedTooltip({
    storageKey: TOOLTIP_DISMISSED_KEY,
  });

  const isNaviItemWithTooltip = !isDismissedTooltip && [NaviKey.Contacts].includes(naviItem.key);

  const MemoizedTooltip = useMemo(() => {
    return (
      <GrTooltip
        content={
          <GrStack gap={4}>
            <GrStack flexDirection="column" gap={4}>
              <GrTypography type="Content.Subtitle04">{MvnMessage(DOCS_CONTACT_LANG.DOCS_CONTACT_TOOLTIP_TITLE)}</GrTypography>
              <GrTypography type="Content.Body04" style={{ wordBreak: "keep-all" }}>
                {MvnMessage(DOCS_CONTACT_LANG.DOCS_CONTACT_TOOLTIP_DESCRIPTION)}
              </GrTypography>
            </GrStack>

            <GrStack height="100%">
              <GrIconButton iconType="x-mark" color="grey060" size={8} onClick={handleDismissedTooltip} />
            </GrStack>
          </GrStack>
        }
        open
        arrow
        placement="right"
        variant="plain"
        style={{ marginLeft: "13px !important", zIndex: baseZIndex.layout.naviItemTooltip }}
      >
        <></>
      </GrTooltip>
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Content = (
    <>
      {startIcon && <GrIcon className="menu-item-icon" size={16} color={isActive ? "white" : "grey070"} type={startIcon} />}
      <Style.NavItemText className="menu-item-text">{label}</Style.NavItemText>
      {endIcon && <GrIcon className="menu-item-icon" size={16} color={isActive ? "white" : "grey070"} type={endIcon} />}
    </>
  );

  return link.isExternal ? (
    <Style.ExternalNavItem href={link.url} target={link.target}>
      {Content}
    </Style.ExternalNavItem>
  ) : (
    <GrStack width="100%" alignItems="center">
      <Style.NavItem $isActive={isActive} to={link.url}>
        {Content}
      </Style.NavItem>
      {isNaviItemWithTooltip && MemoizedTooltip}
    </GrStack>
  );
}
